<template>
  <div>
    <div align="left"></div>
    <app-faq></app-faq>
    <br />
  </div>
</template>

<script>
import Faq from './component/faq';
import Faq_Category from './component/faq_category';

export default {
  components: {
    appFaq: Faq,
    appFaqCategory: Faq_Category,
  },
};
</script>

<style>
</style>
